import React, { useEffect, useState } from "react";
import scheduleService from "../../services/schedule.service";

// type ScheType = {
//   year: Number;
//   term: Number;
//   status: boolean;
//   doc3: string;
//   doc5: string;
//   type: string;
// };

const HeadderSend = (props: any) => {
  const { scheId } = props;
  const [sche, setSche] = useState<any>({});
  useEffect(() => {
    (async () => {
      await scheduleService.getById(scheId).then((res) => {
        setSche(res.data);
      });
    })();
  }, [scheId]);
  return (
    <div className="container mt-2">
      <div
        className={`alert ${
          sche.type === "tqf" ? "alert-primary" : "alert-secondary"
        } text-dark`}
        role="alert"
      >
        <h3 className="mt-2 bg-white rounded-pill p-2">
          <strong>
            กำหนดส่ง {sche.type === "tqf" ? "มคอ." : "อชว."} | RMUTI
            ประจำปีการศึกษา {sche.year} เทอม {sche.term}
          </strong>
        </h3>
        {props.children}
      </div>
    </div>
  );
};

export default HeadderSend;
